import { useState, useEffect, useCallback } from 'react'
import { fetchHistory, saveHistory, deleteHistory, type SaveHistoryPayload } from '../api/redactorApi'
import type { RedactionHistoryItem } from '../types'

export function useHistory() {
  const [history, setHistory] = useState<RedactionHistoryItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const items = await fetchHistory()
      setHistory(items)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load history')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  const save = useCallback(async (payload: SaveHistoryPayload) => {
    console.log('[History] Saving redaction', { tone: payload.tone, audience: payload.audience, messageType: payload.messageType })
    const item = await saveHistory(payload)
    console.log('[History] Saved', { id: item.id })
    setHistory((prev) => [item, ...prev])
    return item
  }, [])

  const remove = useCallback(async (id: string) => {
    console.log('[History] Deleting', { id })
    await deleteHistory(id)
    setHistory((prev) => prev.filter((item) => item.id !== id))
  }, [])

  return { history, loading, error, save, remove, reload: load }
}
